/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".event__date[_ngcontent-%COMP%]{position:relative;font-size:1.4rem;line-height:1;padding-right:1rem;margin-right:1rem}.event__date[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{font-size:3rem}.event__date[_ngcontent-%COMP%]:after{content:\"\";position:absolute;right:0;width:1px;height:38px;top:50%;background-color:#ccc;-webkit-transform:translateY(-50%);transform:translateY(-50%)}"];
export { styles as styles };
